// /composables/useAutosaveAllGoalsTargets.js
import { computed, watch } from 'vue'
import { useAllGoalsStore } from '@/stores/WheelAnalysis/allGoals'
import { useAnalysisStore } from '@/stores/Setup/analysis'

export default function useAutosaveAllGoalsTargets() {
    const allGoals = useAllGoalsStore()
    const analysis = useAnalysisStore()

    // only save when we have an ID and we're not hydrating
    const canSave = computed(() => !!analysis.wheelAnalysisId && !allGoals.isHydrating)

    let t = null
    const DEBOUNCE_MS = 300

    function scheduleSave() {
        if (!canSave.value) return
        clearTimeout(t)
        t = setTimeout(() => {
            try {
                allGoals.selectedTargetsChanged()
            } catch (e) {
                // don't crash autosave
                if (process.env.NODE_ENV !== 'production') {
                    // eslint-disable-next-line no-console
                    console.debug('Autosave selectedTargets failed:', e)
                }
            }
        }, DEBOUNCE_MS)
    }

    // deep watch the 2D grid
    watch(
        () => allGoals.selectedTargets,
        () => scheduleSave(),
        { deep: true }
    )

    // when we transition from not-ready -> ready, flush once if there were edits
    watch(canSave, (ok, wasOk) => {
        if (ok && !wasOk) scheduleSave()
    })
}
